// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<section class="box">
  <sub-header header="\$ctrl.editMode ? 'Edit payment interval' : 'Create payment interval'"></sub-header>

  <form name="\$ctrl.transactionForm">

    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody>
      <tr>
        <td></td>
        <td>Name</td>
        <td>
          <input
            required
            type="text"
            minlength="1"
            maxlength="64"
            ng-model="\$ctrl.paymentIntervalDefinition.name"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Payment interval type</td>
        <td>
          <select
            required
            ng-model="\$ctrl.paymentIntervalDefinition.paymentIntervalType"
            ng-options="it[0] as it[1] for it in \$ctrl.intervalTypes">
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.paymentIntervalDefinition.paymentIntervalType === 'SET_DAYS_OF_THE_MONTH'">
        <td></td>
        <td>Amortization days</td>
        <td>
          <selectize options="\$ctrl.daysOfTheMonth"
                     config="\$ctrl.selectConfig"
                     ng-model="\$ctrl.paymentIntervalDefinition.paymentDays"
                     required>
          </selectize>
        </td>
      </tr>
      <tr ng-if="\$ctrl.paymentIntervalDefinition.paymentIntervalType === 'INTERVAL'">
        <td></td>
        <td>Base interval</td>
        <td>
          <select
            required
            ng-model="\$ctrl.paymentIntervalDefinition.basePaymentInterval"
            ng-options="it[0] as it[1] for it in \$ctrl.basePaymentIntervals">
          </select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.paymentIntervalDefinition.paymentIntervalType === 'INTERVAL'">
        <td></td>
        <td>Interval count</td>
        <td>
          <input
            required
            type="number"
            minlength="1"
            step="1"
            ng-model="\$ctrl.paymentIntervalDefinition.intervalCount"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Accrual limit</td>
        <td>
          <input
            required
            type="number"
            min="1"
            step="1"
            ng-model="\$ctrl.paymentIntervalDefinition.accrualLimit"/>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>CIC Payment Periodicity Domain</td>
        <td>
          <select
            required
            ng-model="\$ctrl.paymentIntervalDefinition.cicPaymentPeriodicity"
            ng-options="it[0] as it[1] for it in \$ctrl.cicTypes">
          </select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>MIDAS Report Periodicity Domain</td>
        <td>
          <select
            required
            ng-model="\$ctrl.paymentIntervalDefinition.midasPaymentPeriodicity"
            ng-options="it[0] as it[1] for it in \$ctrl.midasTypes">
          </select>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        ng-if="!\$ctrl.editMode"
        class="btn btn-success"
        command-access="CreatePaymentIntervalDefinition"
        ng-click="\$ctrl.save()"
        ng-disabled="\$ctrl.transactionForm.\$invalid">
        Create
      </button>
      <button
        ng-if="\$ctrl.editMode"
        class="btn btn-success"
        command-access="EditPaymentIntervalDefinition"
        ng-click="\$ctrl.save()"
        ng-disabled="\$ctrl.transactionForm.\$invalid">
        Save
      </button>
    </div>
  </form>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/intervals/payment-interval-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;